import { t } from '@lingui/core/macro';
import { NoddiCircularLoader } from 'noddi-ui-web';

export const NoddiCircularLoaderWithTrans = () => <NoddiCircularLoader loadingText={t`Loading`} />;
